import { rootApi } from '../rootApi';

const appendFilters = (queryParams, filters) => {
    if (!filters || filters.length === 0) return;

    filters.forEach((filter, index) => {
        queryParams[`Filters[${index}].Column`] = filter.column;
        queryParams[`Filters[${index}].Operator`] = filter.operator;
        queryParams[`Filters[${index}].Value`] = filter.value;
    });
};

const appendSorts = (queryParams, sorts) => {
    if (!sorts || sorts.length === 0) return;

    sorts.forEach((sort, index) => {
        queryParams[`Sorts[${index}].Column`] = sort.column;
        queryParams[`Sorts[${index}].Direction`] = sort.direction;
    });
};

export const repairSlipReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getRepairSlipReport: builder.query({
            query: (params) => {
                const queryParams = {
                    PageNumber: params?.pageNumber ?? 1,
                    PageSize: params?.pageSize ?? 10
                };

                appendFilters(queryParams, params?.filters);
                appendSorts(queryParams, params?.sorts);

                if (params?.includeFilterOptions) {
                    queryParams.IncludeFilterOptions = true;
                    if (params?.filterOptionsColumns && params.filterOptionsColumns.length > 0) {
                        params.filterOptionsColumns.forEach((col, index) => {
                            queryParams[`FilterOptionsColumns[${index}]`] = col;
                        });
                    }
                }

                return {
                    url: 'v1/RepairSlipReport/GetAllReport',
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                if (response?.data) {
                    return {
                        items: response.data.items ?? [],
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['RepairSlipReport']
        }),

        exportRepairSlipReportToExcel: builder.query({
            query: (body) => ({
                url: 'v1/RepairSlipReport/ExportToExcel',
                method: 'POST',
                body: {
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    compressionType: 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || response?.message || 'Export başarısız oldu');
            }
        })
    })
});

export const { useGetRepairSlipReportQuery, useLazyGetRepairSlipReportQuery, useLazyExportRepairSlipReportToExcelQuery } = repairSlipReportApi;
